import moment from 'moment'
import { onMounted, ref, unref } from 'vue'

const FORMULARIO_CACHE_STORAGE_KEY = 'tu.formularioCache'
const DEFAULT_LIMIT = 12

export const MODO_RESULTADO = {
  CARD: 'C',
  TABELA: 'T',
}

export const usePesquisa = ({
  filtro,
  resultado,
  servico,
  nomeResultado,
  nomeDoForm,
  getResultado = (response) => response[nomeResultado],
  recuperarTotal,
  recuperarTodos,
  posPesquisar,
  onNovo,
  onPesquisar,
  onOrdenar,
  onPaginaAlterada,
  onModoAlterado,
  onErro,
  cacheFormularioAtivo = false,
  pesquisarAoMontar = true,
}) => {
  const total = ref(0)
  const pagina = ref(1)
  const modoResultado = ref(MODO_RESULTADO.CARD)

  const garantirFiltroPadrao = () => {
    const filtroAtual = filtro?.value

    if (!filtroAtual) {
      throw new Error(
        'usePesquisa requer que "filtro" seja uma ref contendo um objeto.'
      )
    }

    if (typeof filtroAtual.skip === 'undefined') {
      filtroAtual.skip = 0
    }

    if (typeof filtroAtual.limit === 'undefined') {
      filtroAtual.limit = DEFAULT_LIMIT
    }

    if (typeof filtroAtual.orderBy === 'undefined') {
      filtroAtual.orderBy = ''
    }

    return filtroAtual
  }

  const recuperarFormularioSalvo = () => {
    if (!cacheFormularioAtivo || typeof window === 'undefined') {
      return null
    }

    const formName = unref(nomeDoForm)
    if (!formName) {
      return null
    }

    const rawFormsData = window.localStorage.getItem(
      FORMULARIO_CACHE_STORAGE_KEY
    )

    if (!rawFormsData) {
      return null
    }

    let formsData

    try {
      formsData = JSON.parse(rawFormsData)
    } catch {
      return null
    }

    if (!formsData || !formsData[formName]) {
      return null
    }

    return formsData[formName]
  }

  const aplicarFormularioSalvo = (savedForm) => {
    if (!savedForm) {
      return false
    }

    const filtroAtual = filtro?.value
    if (!filtroAtual) {
      return false
    }

    Object.keys(savedForm).forEach((key) => {
      const isDate = moment(savedForm[key], 'DD/MM/YYYY', true).isValid()

      if (isDate) {
        filtroAtual[key] = moment(savedForm[key], 'DD/MM/YYYY').format()
      } else {
        filtroAtual[key] = savedForm[key]
      }
    })

    return true
  }

  const pesquisar = (skip) => {
    if (onPesquisar) {
      return onPesquisar(skip)
    }

    const filtroAtual = garantirFiltroPadrao()
    const effectiveSkip = typeof skip === 'number' ? skip : 0

    resultado.value = []
    total.value = 0
    pagina.value = effectiveSkip === 0 ? 1 : pagina.value
    filtroAtual.skip = effectiveSkip

    const recuperarTotalFn =
      recuperarTotal || ((filtroAtual) => servico.total(filtroAtual))
    const recuperarTodosFn =
      recuperarTodos || ((filtroAtual) => servico.recuperarTodos(filtroAtual))

    return recuperarTotalFn(filtroAtual).then((result) => {
      if (result?.erro) {
        total.value = 0
        resultado.value = []
        onErro?.(result.erro)
        return null
      }

      const totalResultado =
        typeof result?.total === 'number' ? result.total : 0
      total.value = Math.ceil(totalResultado / filtroAtual.limit)

      if (total.value) {
        return recuperarTodosFn(filtroAtual).then((response) => {
          if (response?.erro) {
            resultado.value = []
            onErro?.(response.erro)
            return null
          }

          resultado.value = getResultado(response) || []
          posPesquisar?.()
          return null
        })
      }

      return null
    })
  }

  const ordenar = (propriedade) => {
    if (onOrdenar) {
      return onOrdenar(propriedade)
    }

    const filtroAtual = garantirFiltroPadrao()
    filtroAtual.orderBy = propriedade
    return pesquisar(0)
  }

  const novo = () => {
    if (onNovo) {
      return onNovo()
    }

    return null
  }

  const paginaAlterada = (page) => {
    if (onPaginaAlterada) {
      return onPaginaAlterada(page)
    }

    const filtroAtual = garantirFiltroPadrao()
    pagina.value = page
    return pesquisar(filtroAtual.limit * (page - 1))
  }

  const modoAlterado = (modo) => {
    if (onModoAlterado) {
      return onModoAlterado(modo)
    }

    modoResultado.value = modo
    return null
  }

  onMounted(() => {
    const aplicouCache = aplicarFormularioSalvo(recuperarFormularioSalvo())

    if (aplicouCache) {
      pesquisar()
      return
    }

    if (!pesquisarAoMontar) {
      return
    }

    pesquisar()
  })

  return {
    nomeResultado,
    nomeDoForm,
    total,
    pagina,
    modoResultado,
    ordenar,
    pesquisar,
    novo,
    paginaAlterada,
    modoAlterado,
  }
}
